import { render, staticRenderFns } from "./TemplatePreviewThumbnail.vue?vue&type=template&id=68c74a9f"
import script from "./TemplatePreviewThumbnail.vue?vue&type=script&lang=js"
export * from "./TemplatePreviewThumbnail.vue?vue&type=script&lang=js"
import style0 from "./TemplatePreviewThumbnail.vue?vue&type=style&index=0&id=68c74a9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports